import { DeliveryCost } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/info/components/deliveryCost";
import { Base } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/info/info.base";

export const Info = Object.assign(Base, {
    DeliveryCost: DeliveryCost
});
